import React, { useState, useEffect } from 'react';
import { Drawer } from '../../common';
import CreateRule from './CreateRule';
import CreateRuleButton from './CreateRuleButton';
import { useStyles } from './styles';
import { COMPARISON } from '../../constants/constant';
import ToastMessages from '../ToastMessages';
import {
	pollStartAction,
	setIsCreateRuleOpen,
	putNotificationsRead,
	setIsNotificationOpen,
	updateSelectedItem,
	updateBulkItemSearchResults,
	createRuleFailure,
	getEditRuleData,
	updateCompareSelectedItemA,
	updateCompareSelectedItemB,
} from '../../redux/actions/createRuleActions';
import { useDispatch, useSelector } from 'react-redux';
import { UserPortalContext } from '../../context/appcontext';
import { Box, useMediaQuery } from '@mui/material';
import Notifications from './NotificationList/Notifications';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';

const AddToWatchListWithButton = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [isToastOpen, setIsToastOpen] = useState(false);

	const isSmallScreen = useMediaQuery('(max-width:600px)');

	const {
		isCreateRuleOpen,
		isCustomizeColOpen,
		ruleType,
		isNotificationOpen,
		data: notifications = [],
	} = useSelector((state) => state.createRuleReducer);
	const portalUserContext = React.useContext(UserPortalContext);

	const viewNotification = () => {
		setIsToastOpen(false);
		dispatch(setIsNotificationOpen(true));

		const request = {
			event: 'view_notifications',
			event_description:
				'User clicks into the "notifications" in the main menu',
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
	};

	useEffect(() => {
		dispatch(pollStartAction({ portalUserContext }));
	}, []);

	useEffect(() => {
		let flag = false;
		for (const notification of notifications) {
			if (notification?.read === false) {
				flag = true;
				setIsToastOpen(true);
				break;
			}
		}
		if (!flag) {
			setIsToastOpen(false);
		}
	}, [isToastOpen, notifications]);

	const onNotificationClose = () => {
		dispatch(setIsNotificationOpen(false));
		// Dispatch Put notification read
		dispatch(putNotificationsRead({ portalUserContext }));
	};

	const drawserClose = () => {
		dispatch(setIsCreateRuleOpen(false));
		[
			'store',
			'item',
			'category',
			'subcategory',
			'brand',
			'department',
			'upc',
		].forEach((type) => {
			dispatch(updateCompareSelectedItemA({ [type]: [] }));
			dispatch(updateCompareSelectedItemB({ [type]: [] }));
			dispatch(updateSelectedItem({ [type]: [] }));
			dispatch(updateBulkItemSearchResults({ [type]: [] }));
		});
		dispatch(createRuleFailure(0));
		dispatch(getEditRuleData(null));
	};

	return (
		<Box className={classes.plusButtonContainer}>
			{!isSmallScreen && (
				<ToastMessages
					open={isToastOpen}
					viewDetailsHandler={viewNotification}
					toastHandler={setIsToastOpen}
				/>
			)}

			{isCreateRuleOpen || isNotificationOpen || isCustomizeColOpen ? null : (
				<CreateRuleButton width={240} />
			)}

			{/* Create Rule */}
			<Drawer
				className="test-drawer"
				open={isCreateRuleOpen}
				onClose={drawserClose}
				width={ruleType === COMPARISON ? (isSmallScreen ? 360 : 768) : 360}>
				<CreateRule drawserClose={drawserClose} />
			</Drawer>
			{/* Notification w/ Drawer */}
			<Notifications onClose={onNotificationClose} />
		</Box>
	);
};

export default AddToWatchListWithButton;
